// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchItem_wrapper__33_zB","content-container":"SearchItem_content-container__2djCw","image":"SearchItem_image__2tPlv"};